/**
 * OfficeIcon/index.js
 * desc: office icon
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const OfficeIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="office icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.office.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 20 18" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 4h10v14H0V0h10v4zM2 16h2v-2H2v2zm2-4H2v-2h2v2zM2 8h2V6H2v2zm2-4H2V2h2v2zm2 12h2v-2H6v2zm2-4H6v-2h2v2zM6 8h2V6H6v2zm2-4H6V2h2v2zm10 12V6h-8v2h2v2h-2v2h2v2h-2v2h8zm-2-8h-2v2h2V8zm-2 4h2v2h-2v-2z" /></svg>
    </IconButton>
);


export default OfficeIcon;
